export const PROVINCE_NOT_FOUND =
	'A province with a postal code was not found ';
export const ERROR_PROVINCE = 'Error! Province:';
export const NO_RUNNING_PROMO =
	'We are currently not running a promotional offer for this region. (Sale at a price of 9800 Kč)';
export const CORRECT_PROVINCE = 'Postal code correct!  Province: ';
export const SUCCESS_PROMO =
	' The customer can take advantage of the promotional offer.';
